import { inject, Injectable } from '@angular/core';
import { UiToastService } from '@shared/components/ui';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private uiToastService = inject(UiToastService);

  show(
    position:
      | 'top-left'
      | 'top-center'
      | 'top-right'
      | 'bottom-left'
      | 'bottom-center'
      | 'bottom-right'
      | 'center',
    type: 'success' | 'info' | 'warn' | 'error' | 'contrast' | 'secondary',
    summary: string,
    detail: string
  ) {
    this.uiToastService.show(position, type, summary, detail);
  }
}
